/**
 * CORE-618 — the GetStream channel operations that used to live here (send /
 * react / pin / typing / media / voice, all bound to a `stream-chat` Channel)
 * were removed with the Stream transport. The Agape.ChatApi path
 * (`ChatApiChannel` + `useChatThread`) owns those now. Only the upload payload
 * shapes survive, shared by the native composer.
 */

export interface MediaUpload {
  uri: string;
  type: 'image' | 'video';
  name: string;
  mime: string;
  width?: number;
  height?: number;
}

export interface VoiceUpload {
  uri: string;
  durationMs: number;
  waveform: number[];
}
